import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICamp } from '../../../types/camp.types';
import { fetchCamps } from './ActionCreators';

interface CampState {
  camps: ICamp[];
  isLoading: boolean;
  error?: any;
}

const initialState: CampState = {
  camps: [],
  isLoading: false,
};

export const campSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCamps: (state, action: PayloadAction<ICamp[]>) => {
      state.camps = action.payload;
    },
    setLoadingCamps: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
  extraReducers: {
    [fetchCamps.fulfilled.type]: (state, action: PayloadAction<ICamp[]>) => {
      state.isLoading = false;
      state.camps = action.payload;
      state.error = '';
    },
    [fetchCamps.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchCamps.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { setCamps, setLoadingCamps } = campSlice.actions;
export default campSlice.reducer;
